export interface Alert {
  severity: AlertSeverity;
  message: string;
  timeoutMS: number;
}

export enum AlertSeverity {
  Success = 'success',
  Error = 'error',
}

export type MenuItemHandler = () => void;

export interface MenuItem {
  label: string;
  icon: string;
  handler: MenuItemHandler;
}

/**
 * Represents a navigation item with a label, target URL, and icon.
 * @interface
 */
export interface NavItem {
  /** The label text of the navigation item. */
  label: string;
  /** The target URL of the navigation item. */
  target: string;
  /** The URL or identifier of the icon associated with the navigation item. */
  icon: string;
}
